import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Swords } from "lucide-react";
import { Link } from "react-router-dom";
import { SidebarMenu, SidebarMenuButton } from "@/components/ui/sidebar";
import { isActive } from "@/lib/utils";
import { adminPath } from "@/routes/path_helpers/admin";
export function NavFooter({ path }) {
    return (_jsx(SidebarMenu, { children: _jsx(SidebarMenuButton, { asChild: true, isActive: isActive(path, adminPath()), children: _jsxs(Link, { to: adminPath(), className: "!no-underline", children: [_jsx(Swords, {}), _jsx("span", { children: "Systemadministration" })] }) }) }));
}
